import type { InferType } from "yup";
import * as yup from "yup";

import api from "../utils/AxiosInterceptor";
import i18n from "../i18n";

export const loginSchemaInput = yup.object({
  document: yup
    .string()
    .required(() => i18n.t("validation.cpfRequired"))
    .validateCpf(),
  password: yup.string().required(() => i18n.t("validation.passwordRequired")),
});

export type LoginInput = InferType<typeof loginSchemaInput>;

interface LoginResponse {
  token: string;
  user: LoggedUser;
}
export async function login(input: LoginInput): Promise<LoginResponse> {
  const response = await api.post(`/api/v1/auth/signin`, input);
  return response.data as LoginResponse;
}
